import { ActionTypes } from '../constants';

export default function updateReturnShippingLanePage(pageNumber: number) {
  return {
    type: ActionTypes.UPDATE_RETURN_SHIPPING_LANES_PAGE,
    payload: pageNumber,
  };
}
